import worldTradeCentreData from '../../data/worldTradeCentre.json';
import Project from '../../component/Project';

const WorldTradeCentre = () => {
  const { pageData, containerData, content, images, styles } = worldTradeCentreData;

  return (
   <Project pageData={pageData} containerData={containerData} content={content} images={images} styles={styles} />
  );
};

export default WorldTradeCentre;